import React, { Component } from "react";
import Swiper from "react-id-swiper";
import ApiAssets from "../../utils/api.assets";
import AssetPage from "./index";
import Loading from "../../components/Loading/index";

declare var location;

class SwipePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assetline: "",
      asset: {
        parents: []
      },
      loading: true,
      paramsSwipe: {
        // init: true,
        rebuildOnUpdate: true,
        effect: "coverflow",
        speed: 300,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next.customized-swiper-button-next", // Add your class name for next button
          prevEl: ".swiper-button-prev.customized-swiper-button-prev" // Add your class name for prev button
        }
      }
    };

    if (location.search) {
      let assetline = location.search.split("=")[1];
      this.loadCurrentAsset(assetline);
    }

    this.props.history.listen(e => {
      if (e.search) {
        let queryStr = e.search;
        let query = {};

        queryStr
          .substr(1, queryStr.length - 1)
          .split("&")
          .forEach(str => {
            let parse = str.split("=");
            query[parse[0]] = parse[1];
          });

        if (query["buy"]) {
          this.setState(...this.state, { buying: true });
        } else {
          this.setState(...this.state, { buying: false });
        }

        if (query["bid"]) {
          this.toggleAuction();
        }

        this.loadCurrentAsset(query["assetline"]);
      }
    });

    this.loadCurrentAsset = this.loadCurrentAsset.bind(this);
  }

  loadCurrentAsset(assetline) {
    this.setState(...this.state, { loading: true });

    ApiAssets.get(assetline).then(response => {
      if (response.data) {
        let currentName = response.data.info.name;
        let parents = response.data.parents;
        let beforeParents = [];
        let found = false;

        parents = parents.sort((a, b) => {
          if (a.info.order_planets && b.info.order_planets) {
            return a.info.order_planets < b.info.order_planets ? -1 : a.info.order_planets > b.info.order_planets ? 1 : 0;
          } else {
            return a.info.previous_landers[0].previous_lander_asset_price < b.info.previous_landers[0].previous_lander_asset_price ? -1 : a.info.previous_landers[0].previous_lander_asset_price > b.info.previous_landers[0].previous_lander_asset_price ? 1 : 0;
          }
        });

        parents = parents.filter(parent => {
          if (parent.info.name === currentName) {
            found = true;
          } else if (!found) {
            beforeParents.push(parent);
          }

          return found;
        });

        parents = [...parents, ...beforeParents];

        response.data.parents = parents;

        if (parents.length <= 1) {
          this.setState({
            paramsSwipe: {
              // init: true,
              rebuildOnUpdate: true,
              effect: "coverflow",
              speed: 300,
              spaceBetween: 30,
              loop: false
            }
          });
        } else {
          this.setState({
            paramsSwipe: {
              // init: true,
              rebuildOnUpdate: true,
              effect: "coverflow",
              speed: 300,
              spaceBetween: 30,
              loop: false,
              navigation: {
                nextEl: ".swiper-button-next.customized-swiper-button-next", // Add your class name for next button
                prevEl: ".swiper-button-prev.customized-swiper-button-prev" // Add your class name for prev button
              }
            }
          });
        }

        this.setState({
          loading: false,
          assetline: assetline,
          asset: response.data
        });
      }
    });
  }

  render() {
    return (
      <div>
        <Loading active={this.state.loading} />
        <Swiper {...this.state.paramsSwipe}>
          {this.state.asset.parents.map(asset => {
            return (
              <div>
                <AssetPage
                  key={asset.key}
                  asset={asset}
                  loadCurrentAsset={this.loadCurrentAsset}
                />
              </div>
            );
          })}
        </Swiper>
      </div>
    );
  }
}

export default SwipePage;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/index.swipe.js